/** Identity as the SPA sees it. */
export function isAuthenticated(session) {
    return session.authenticated;
}
export function hasRole(session, role) {
    return isAuthenticated(session) && session.user.roles.includes(role);
}
//# sourceMappingURL=session.js.map